import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {createShadowElementForTrigger} from "./Utils";

export default class Scrub {
    constructor(scene, scrubs) {
        this.scene = scene;
        this.scrubs = scrubs;
        this.triggers = [];
        this.enabled = false;
    }

    async init() {
        if (this.scrubs == null) {
            return
        }

        for (const scrubItem of this.scrubs) {
            const queryUuid = `#${scrubItem.uuid}`
            const target = this.scene.runSelector(queryUuid)[0]
            if (target == null) {
                continue // go to next iteration if no target is found
            }

            const viewHeight = this.scene.spread.getWindowHeight()
            const sceneScale = parseFloat(this.scene.getSceneElement(false).style.getPropertyValue('--sceneScale')) ?? 1;

            const stickyEnabled = target.classList.contains('grid-sticky')
            const stickyMargin = window.getComputedStyle(target).getPropertyValue('--sticky-margin-px');
            const stickyScrub = window.getComputedStyle(target).getPropertyValue('--sticky-for') * sceneScale
            let triggerTarget = stickyEnabled ? createShadowElementForTrigger(target, this.scene.getSceneElement(false), { direction: 'scrub' }) : target

            switch (scrubItem.type) {
                case 'video': {
                    const duration = target.getAttribute('data-duration')
                    scrubItem.to = {...scrubItem.to, currentTime: duration - 0.5 || 0 } // scrub to half a second less than the full duration, to prevent it jump back to the first frame
                } break
                case 'slideshow': {
                    scrubItem.onUpdate = (self) => {
                        const count = target.getAttribute('data-slidecount')
                        const index = Math.round(self.progress * count)
                        this.scene.slideshows?.doAction(target, index)
                    }
                } break
                // case 'chart': {
                //     scrubItem.onUpdate = (self) => {
                //         this.scene.charts?.updateScrub(queryUuid, self.progress)
                //     }
                // } break
                case 'webcomponent': {
                    scrubItem.onUpdate = (self) => {
                        // Start a loop that checks the animation progress
                        const checkProgress = () => {
                            const currentProgress = self.animation.progress();
                            this.seek(queryUuid, currentProgress);
                            if (Math.abs(currentProgress - self.progress) > 0.001) {
                                requestAnimationFrame(checkProgress);
                            }
                        };
                        checkProgress();
                    }
                } break
                default: {
                } break
            }

            const scrubStart = () => {
                const startMatch = scrubItem.start.match(/(top|center|bottom)\s+(\d+)%/);
                if (startMatch) {
                    const startDirection = startMatch[1];
                    const startPercentage = parseInt(startMatch[2], 10) * 0.01;
                    const startOffset = startDirection === 'bottom' ? target.offsetHeight : startDirection === 'center' ? target.offsetHeight * 0.5 : 0
                    if (viewHeight * (1 - startPercentage) + startOffset > viewHeight - stickyMargin) {
                        return `clamp(${scrubItem.start}-=${stickyScrub})`
                    }
                }
                return `clamp(${scrubItem.start})`
            }
            const scrubEnd = () => {
                const endMatch = scrubItem.end.match(/(top|center|bottom)\s+(\d+)%/);
                if (endMatch) {
                    const endDirection = endMatch[1];
                    const endPercentage = parseInt(endMatch[2], 10) * 0.01;
                    const endOffset = endDirection === 'top' ? target.offsetHeight : endDirection === 'center' ? target.offsetHeight * 0.5 : 0
                    if (viewHeight * (1 - endPercentage) + endOffset < viewHeight - stickyMargin - target.offsetHeight) {
                        return scrubItem.end
                    }
                }
                if (scrubItem.mode === 'viewport') {
                    return `${scrubItem.end}-=${stickyScrub}`
                }
                return scrubItem.end;
            }
            const animationTarget = scrubItem.type === 'video' ? `#video_${scrubItem.uuid}-${this.scene.spread.spread_id}` : queryUuid;
            const animation = gsap.fromTo(scrubItem.to ? animationTarget : { progress: 0 }, scrubItem.from, scrubItem.to ?? { progress: 100 })
            const scrubSettings = {
                trigger: triggerTarget,
                start: scrubStart,
                end: scrubEnd,
                scrub: scrubItem.scrub,
                onUpdate: scrubItem.onUpdate,
                animation: animation,
                markers: false,
                id: scrubItem.type,
            }


            const scrollTrigger = ScrollTrigger.create(scrubSettings)
            if (!this.enabled) {
                scrollTrigger.disable()
            }
            this.triggers.push(scrollTrigger)
        }
    }

    stop() {
        this.disableAll()
    }

    enableAll() {
        this.enabled = true;
        this.triggers.forEach(trigger => trigger.enable())
    }

    disableAll() {
        this.enabled = false;
        this.triggers.forEach(trigger => trigger.disable())
    }

    seek(uuid, progress) {
        this.scene.runSelector(uuid)[0].children[0].seek(progress)
    }
}
